"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ToggleSwitch = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ToggleSwitch = ({
  className,
  checked,
  disabled,
  offColor,
  onColor,
  offHandleColor,
  onHandleColor,
  id,
  onChange,
  labelText,
  showLabel,
  ariaLabel,
  // height,
  // width,
  ...rest
}) => {
  let baseClass = "sp-toggleswitch";
  let toggleSwitchClasses = (0, _classnames.default)(className, `${baseClass}`, disabled ? `${baseClass}-disabled` : `${baseClass}-enabled`);
  const colorStyle = {
    "--offColor": offColor,
    "--onColor": onColor,
    "--onHandleColor": onHandleColor,
    "--offHandleColor": offHandleColor
  };
  const primaryCheck = checked !== null && checked !== undefined ? checked : defaultisChecked;
  const [defaultisChecked, setdefaultisChecked] = (0, _react.useState)(primaryCheck);

  const switchToggle = evt => {
    setdefaultisChecked(evt.target.checked);
  };

  const toggleChange = onChange !== null && onChange !== undefined ? onChange : switchToggle;
  const ariaProps = {
    "aria-label": ariaLabel
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: toggleSwitchClasses,
    id: id
  }, ariaProps), showLabel && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "sp-checkbox-text",
    role: "checkbox",
    htmlFor: "sp-checkbox",
    "aria-checked": defaultisChecked && primaryCheck,
    tabIndex: "0",
    "aria-labelledby": labelText
  }, labelText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    id: "sp-checkbox",
    disabled: disabled,
    checked: defaultisChecked && primaryCheck,
    onChange: evt => toggleChange(evt)
  }), /*#__PURE__*/_react.default.createElement("label", {
    style: colorStyle
  })));
};

exports.ToggleSwitch = ToggleSwitch;
ToggleSwitch.defaultProps = {
  showLabel: false,
  checked: false,
  disabled: false,
  offColor: "#fff",
  onColor: "#41d87d",
  offHandleColor: "#bbb",
  onHandleColor: "#95e9b7",
  disabled: false,
  id: "",
  // height: "24px",
  // width: "24px",
  labelText: "Activate" // checkedIcon: "",
  // uncheckedIcon: ""

};
ToggleSwitch.propTypes = {
  className: _propTypes.default.string,
  checked: _propTypes.default.oneOf([true, false]),
  disabled: _propTypes.default.oneOf([true, false]),
  style: _propTypes.default.object,
  offColor: _propTypes.default.string,
  onColor: _propTypes.default.string,
  offHandleColor: _propTypes.default.string,
  onHandleColor: _propTypes.default.string,
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  onChange: _propTypes.default.func,
  ariaLabel: _propTypes.default.string,
  showLabel: _propTypes.default.bool,
  labelText: _propTypes.default.string // height: PropTypes.oneOf(enums.toggleSize),
  // width: PropTypes.oneOf(enums.toggleSize),
  // checkedIcon: PropTypes.element,
  // uncheckedIcon: PropTypes.element,
  // handleborderRadius: PropTypes.string,

};
var _default = ToggleSwitch;
exports.default = _default;